const cards = [
  {
    title: '《流浪地球3》为什么值得二刷',
    desc: '从视效到剧情全面升级，国产科幻的里程碑之作，4K超清画质下每一帧都是壁纸。',
    img: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20scene%20with%20futuristic%20space%20station%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20warm%20golden%20and%20crimson%20accents%2C%20cinematic%20atmosphere&width=500&height=350&seq=card-1&orientation=landscape',
    tag: '影评',
  },
  {
    title: '《庆余年2》全集观后感',
    desc: '范闲归来，权谋升级。第二季在保持原著精髓的同时，人物塑造更加立体丰满。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20cinematic%20scene%2C%20ancient%20palace%20interior%2C%20warm%20candlelight%2C%20elegant%20costume%2C%20golden%20amber%20tones%2C%20dramatic%20mood&width=500&height=350&seq=card-2&orientation=landscape',
    tag: '剧评',
  },
  {
    title: '暑期追剧指南：这10部高分剧不容错过',
    desc: '从国产口碑到海外佳作，盘点暑期最值得追的高清电视剧，拯救你的剧荒。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20entertainment%20collage%20with%20TV%20and%20film%20elements%2C%20warm%20sunny%20atmosphere%2C%20golden%20lighting%2C%20cozy%20home%20viewing%20setup%2C%20cinematic%20aesthetic&width=500&height=350&seq=card-3&orientation=landscape',
    tag: '盘点',
  },
  {
    title: '4K超清 vs 1080P：观影体验差距有多大',
    desc: '老子影视网全站4K超清画质，带你感受真正的高清视觉盛宴，细节一览无余。',
    img: 'https://readdy.ai/api/search-image?query=Cinema%20screen%20comparison%20visual%2C%20high%20resolution%20display%2C%20crisp%20details%2C%20warm%20cinematic%20lighting%2C%20professional%20color%20grading%2C%20elegant%20tech%20aesthetic&width=500&height=350&seq=card-4&orientation=landscape',
    tag: '科普',
  },
  {
    title: '《繁花》里的上海：一部剧一座城',
    desc: '王家卫镜头下的上海风情，年代质感与人物命运交织，高清画质还原每一处细节。',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Shanghai%20street%20scene%20at%20night%2C%20neon%20lights%2C%20nostalgic%201990s%20atmosphere%2C%20warm%20amber%20tones%2C%20cinematic%20composition%2C%20elegant%20urban%20mood&width=500&height=350&seq=card-5&orientation=landscape',
    tag: '剧评',
  },
  {
    title: '国产动漫崛起：这些国漫比日漫还好看',
    desc: '从《哪吒》到《深海》，国产动漫制作水准飞跃提升，高清全集免费在线观看。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%2C%20beautiful%20fantasy%20scene%2C%20vibrant%20colors%20with%20warm%20golden%20lighting%2C%20artistic%20composition%2C%20dreamy%20atmosphere%2C%20elegant%20visual&width=500&height=350&seq=card-6&orientation=landscape',
    tag: '盘点',
  },
  {
    title: '周末观影指南：5部冷门高分佳片',
    desc: '评分高但被忽略的好电影，老子影视网高清资源库帮你挖掘这些隐藏的宝藏。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20home%20cinema%20setup%20with%20warm%20lighting%2C%20film%20projector%20aesthetic%2C%20golden%20hour%20mood%2C%20comfortable%20viewing%20atmosphere%2C%20cinematic%20interior%2C%20elegant%20design&width=500&height=350&seq=card-7&orientation=landscape',
    tag: '推荐',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">影视资讯</h2>
          <p className="mt-2 text-sm text-foreground-500">最新影视动态、深度影评与观影指南</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 6).map((card) => (
            <div
              key={card.title}
              className="rounded-lg bg-background-100 border border-background-200/60 overflow-hidden group cursor-pointer hover:border-background-300/60 transition-colors"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-md mb-2 whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="text-sm font-medium text-foreground-800 mb-1.5">{card.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5">
          {cards.slice(6).map((card) => (
            <div
              key={card.title}
              className="rounded-lg bg-background-100 border border-background-200/60 overflow-hidden group cursor-pointer hover:border-background-300/60 transition-colors flex flex-col sm:flex-row"
            >
              <div className="w-full sm:w-48 flex-shrink-0 aspect-video sm:aspect-auto overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 flex-1">
                <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-md mb-2 whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="text-sm font-medium text-foreground-800 mb-1.5">{card.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}